export enum StatusCode {
	ReachLimit = 333032,
	BusyService = 411003, // 任务超限制 (目前非会员1限制)
	BusyServiceVip = 411004, // 任务超限制 (会员3限制)
	NoEnhanceBenefit = 810201,
	GenerateVideoNoAuth = 333035, // 视频任务无权限
	GenerateVideoReachLimit = 333034, // 视频任务达到上限
	GenerateDisabled = 324027, // 用户为无限积分会员不可用长视频生成
	ResolutionVideoLimit = 333039, // 像一些动作模仿生成的长视频通过特殊场景走了结果页的高清按钮, 然后后端那边也会拦, 就通过这个状态码
	VsrHdPixelsExceeded = 310206, // 视频超分：画质已高于 HD
	VsrFhdPixelsExceeded = 310207, // 视频超分：画质已高于 FHD
	UnsupportedItem = 622002, // 不支持的表单组件（如已下线 filter）
	InfiniteTalkPromptTooLong = 622701, // 数字人组件人声文本过长
}
